import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getHistory } from "../../../../store/actions/maintenanceOrderByActions";
import {
  ReusableHistoryViewer,
  mapDescriptionHistoryRows,
} from "../../../../components/History";

const PAGE_SIZE = 20;

const ORDER_BY_HISTORY_ENTITY_LABELS = {
  order_by: "Order By",
};

export default function OrderByHistory({ code }) {
  const dispatch = useDispatch();
  const ordersLocation = useSelector(
    ({ orderReducer }) => orderReducer.ordersLocation,
  );

  const fetchOrderByHistoryPage = useCallback(
    async (page, size) => {
      if (!code || !ordersLocation?.locationNumber) {
        return {
          history: [],
          pagination: { hasMore: false },
        };
      }

      const res = await dispatch(
        getHistory(
          ordersLocation.locationNumber,
          code,
          page,
          size,
        ),
      );

      const rawHistory = Array.isArray(res?.data) ? res.data : [];
      const history = mapDescriptionHistoryRows(rawHistory, {
        entity: "order_by",
        entityId: code || "general",
        fieldName: "Description",
        pageSeed: page,
      });

      return {
        history,
        pagination: { hasMore: rawHistory.length >= size },
      };
    },
    [code, dispatch, ordersLocation?.locationNumber],
  );

  return (
    <ReusableHistoryViewer
      fetchHistoryPage={fetchOrderByHistoryPage}
      reloadKey={`${ordersLocation?.locationNumber || "none"}-${code || "none"}`}
      title="Order By History"
      searchPlaceholder="Search by user or description"
      entityLabels={ORDER_BY_HISTORY_ENTITY_LABELS}
      initialExpandedGroups={3}
      pageSize={PAGE_SIZE}
    />
  );
}
